/**
 * @description Keep pack SO operators off LynxPay SO money routes (LYN-356)
 *
 * @notes Views read the pack boolean. Hostname / slug are not the gate.
 */

import { Navigate } from 'react-router-dom';
import { useCompany } from '../../../contexts/CompanyContext';
import { usePackChrome } from '../../../contexts/PackChromeContext';

export default function PackLynxPayRedirect({ children }) {
  const { towtechSoChrome, loading } = usePackChrome();
  const { hasCompany } = useCompany();

  if (loading) {
    return null;
  }

  if (towtechSoChrome) {
    return <Navigate to={hasCompany ? '/so/company' : '/so/dashboard'} replace />;
  }

  return children;
}
